import styled from 'styled-components';
import { Popover } from 'antd';


export const HiddenParticipantsCounter = styled.span`
  color: ${({ theme }) => theme.colors.fontSilverLight};
  cursor: pointer;
`;

export const ParticipantsWrapper = styled(Popover)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/styles.js